import { useContext } from "react";
import AuthContext from "../store/auth-context";
import { useSelector } from "react-redux";

export function formatTime12Hour(timestamp) {
  if (!timestamp) {
    return "-- : --";
  }

  const date = new Date(timestamp);
  let time = `${date.getHours()}: ${date.getMinutes()}`;
  return time;
}

export function formattedDate(value) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  let date = new Date(value);
  let formatedYear = date.getFullYear();
  let formatedDay = `${
    months[Math.abs(date.getMonth())]
  } ${date.getDate()}, ${formatedYear}`;

  return { formatedDay, formatedYear };
}

//Returns true if delete or backspace is clicked
export function isKeyDelete(nativeEvent) {
  return (
    nativeEvent.inputType === "deleteContentBackward" ||
    nativeEvent.inputType === "deleteContentForward" ||
    nativeEvent.which === 8
  );
}

//returns true if email valid
export function verifyEmail(value) {
  var emailRex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (emailRex.test(value)) {
    return true;
  }
  return false;
}

// Returns true if password is valid
export function verifyPassword(value) {
  var passRex = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,32}$/;
  return passRex.test(value);
}

//returns true if length is valid
export function verifyLength(value, length) {
  if (value.length >= length) {
    return true;
  }
  return false;
}

//returns true if phoneNumber is valid
export function verifyPhoneNumber(value, country) {
  if (country === "USA") {
    // Format for USA: (999) 999-9999
    var phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  } else if (country === "India") {
    // Format for India: 99999-99999
    var phoneRegex = /^([0-9]{5})[-]?([0-9]{5})$/;
  }

  if (phoneRegex?.test(value)) {
    return true;
  } else {
    return false;
  }
}

export function formatDateInv(dateString) {
  const date = new Date(dateString);

  const options = { day: "2-digit", month: "long", year: "numeric" };

  const formattedDate = date
    .toLocaleDateString("en-GB", options)
    .replace(",", "");

  return formattedDate;
}

export const indv = -1;

export function getAuthorizationHeader() {
  const accessToken = localStorage.getItem("accessToken");
  if (accessToken) {
    return {
      headers: {
        "Access-Control-Allow-Origin": "*",
        Authorization: "Bearer " + accessToken,
      },
    };
  } else {
    throw new Error("Access token not found");
  }
}

export function getExpiryString(expirationDate) {
  const daysLeft = Math.floor(
    (expirationDate - Date.now()) / (1000 * 60 * 60 * 24),
  );
  return daysLeft > 0 && `${daysLeft} Days`;
}

export function getExpiryNumber(expirationDate) {
  const daysLeft = Math.floor(
    (expirationDate - Date.now()) / (1000 * 60 * 60 * 24),
  );
  return daysLeft > 0 && `${daysLeft}`;
}

export function getPlanProgress(planCreation, planExpiry) {
  const now = Date.now();

  const totalDays = Math.floor(
    (planExpiry - planCreation) / (1000 * 60 * 60 * 24),
  ); // full plan length

  const daysLeft = Math.floor((planExpiry - now) / (1000 * 60 * 60 * 24)); // remaining

  const daysPassed = totalDays - daysLeft;

  return {
    totalDays: totalDays > 0 ? totalDays : 0,
    daysLeft: daysLeft > 0 ? daysLeft : 0,
    daysPassed: daysPassed > 0 ? daysPassed : 0,
    progress: totalDays > 0 ? (daysPassed / totalDays) * 100 : 0,
  };
}

export function getUsage(featureType, planFeatures) {
  return planFeatures?.reduce(
    (acc, feature) => {
      if (feature.type === featureType) {
        acc.used = feature.used;
        acc.limitOrAvailablity = feature.limitOrAvailablity;
      }
      return acc;
    },
    { used: "0", limitOrAvailablity: "0" },
  );
}

export function getOrgIdByOrgname(orgName, organizationsInfo) {
  const orgData = organizationsInfo?.dashboardOrg?.data.find(
    (org) => org.name === orgName,
  );
  return orgData ? orgData.orgId : null;
}

export function formatDate(timestamp) {
  const date = new Date(timestamp);

  // Options for formatting the date
  const options = { month: "short", day: "numeric", year: "numeric" };

  // Convert to formatted date string
  const formattedDate = date.toLocaleDateString("en-US", options);

  // Add ordinal suffix to the day
  const day = date.getDate();
  const suffix =
    day === 1 || day === 21 || day === 31
      ? "st"
      : day === 2 || day === 22
        ? "nd"
        : day === 3 || day === 23
          ? "rd"
          : "th";

  // Format final date string
  return `${formattedDate.replace(/(\d+),/, `$1${suffix},`)}`;
}

export function getFormattedDate(timestamp) {
  const date = new Date(timestamp);
  const now = new Date();
  const timeDifference = now - date;
  const secondsInMinute = 60 * 1000;
  const secondsInHour = 60 * secondsInMinute;
  const secondsInDay = 24 * secondsInHour;

  if (timeDifference < secondsInMinute) {
    const seconds = Math.floor(timeDifference / 1000);
    return `${seconds} second${seconds === 1 ? "" : "s"} ago`;
  } else if (timeDifference < secondsInHour) {
    const minutes = Math.floor(timeDifference / secondsInMinute);
    return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
  } else if (timeDifference < secondsInDay) {
    const hours = Math.floor(timeDifference / secondsInHour);
    return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  } else {
    const days = Math.floor(timeDifference / secondsInDay);
    return `${days} day${days === 1 ? "" : "s"} ago`;
  }
}

export function formatUsTimestamp(value) {
  if (!value) return "";

  const valueString = String(value).trim();
  const [datePart = "", ...relativeParts] = valueString
    .split(",")
    .map((part) => part.trim());
  const normalizedValue = datePart;
  const relativeText = relativeParts.join(", ");

  const indiaFormatMatch = normalizedValue.match(
    /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/,
  );
  if (indiaFormatMatch) {
    const [, day, month, year] = indiaFormatMatch;
    const usDate = `${month.padStart(2, "0")}/${day.padStart(2, "0")}/${year}`;
    return relativeText ? `${usDate}, ${relativeText}` : usDate;
  }

  const date = new Date(normalizedValue);
  if (Number.isNaN(date.getTime())) {
    return relativeText
      ? `${normalizedValue}, ${relativeText}`
      : normalizedValue;
  }

  const usDate = new Intl.DateTimeFormat("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  }).format(date);

  return relativeText ? `${usDate}, ${relativeText}` : usDate;
}

const colors = [
  {
    dark: "#34629D",
    light: "rgba(52, 98, 157, 0.1)",
  },
  {
    dark: "#C5A32C",
    light: "rgba(197, 163, 44, 0.1)",
  },
  {
    dark: "#AE3FC9",
    light: "rgba(174, 63, 201, 0.1)",
  },
  {
    dark: "#C5482C",
    light: "rgba(197, 72, 44, 0.1)",
  },
  {
    dark: "#2AC078",
    light: "rgba(42, 192, 120, 0.1)",
  },
]; // Add more colors as needed

export function getColorPairForName(name) {
  if (!name) return { dark: "#ccc", light: "#f0f0f0" }; // Default colors for undefined names
  const hash = [...name].reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return colors[hash % colors.length];
}

export function formatFileSize(bytes) {
  if (!bytes || bytes === 0) return "0 B"; // Ensure valid input

  const units = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const index = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, index)).toFixed(1)} ${units[index]}`;
}

export function convertToYearlyPrice(salePrice) {
  return (salePrice * 12).toFixed(2);
}

// export function formattedDates(value) {
//   const months = [
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//   ];

//   let date = new Date(value);
//   let formattedYear = date.getFullYear();
//   let formattedDay = `${
//     months[Math.abs(date.getMonth())]
//   } ${date.getDate()}, ${formattedYear}`;

//   return formattedDay;
// }

export function formattedDates(value) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const date = new Date(value);

  // Date
  const year = date.getFullYear();
  const month = months[date.getMonth()];
  const day = date.getDate();

  // Time
  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  // Convert 24h → 12h format
  hours = hours % 12 || 12;

  // Zero pad minutes
  minutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${month} ${day}, ${year} · ${hours}:${minutes} ${ampm}`;
}

// Function to format phone number based on country
export function PhoneNumberformat(phoneNumber, country) {
  const cleaned = phoneNumber.replace(/\D/g, "");
  if (country === "USA") {
    if (cleaned.length > 3) {
      const formattedNumber = cleaned.replace(
        /^(\d{3})(\d{0,3})(\d{0,4})/,
        "($1) $2-$3",
      );
      return formattedNumber.substring(0, 14);
    }
  } else if (country === "India") {
    if (cleaned.length > 5) {
      const formattedNumber = cleaned.replace(/^(\d{5})(\d{0,5})/, "$1-$2");
      return formattedNumber.substring(0, 11);
    }
  }

  return cleaned;
}

export function formatPhoneNumber(phoneNumber, country) {
  if (country === "USA") {
    phoneNumber = phoneNumber.substring(2); // Remove "+1" for USA
    const areaCode = phoneNumber.substring(0, 3);
    const firstPart = phoneNumber.substring(3, 6);
    const secondPart = phoneNumber.substring(6, 10);
    return `(${areaCode}) ${firstPart}-${secondPart}`;
  } else if (country === "India") {
    phoneNumber = phoneNumber.substring(3); // Remove "+91" for India
    const firstPart = phoneNumber.substring(0, 5);
    const secondPart = phoneNumber.substring(5, 10);
    return `${firstPart}-${secondPart}`;
  }
}

export function formatIndianCurrency(number) {
  if (number === undefined || number === null || isNaN(number)) {
    return "";
  }

  let str = number.toString().replace(/,/g, "");
  let [integer, decimal] = str.split(".");

  let lastThree = integer.slice(-3);
  let otherNumbers = integer.slice(0, -3);

  if (otherNumbers !== "") {
    lastThree = "," + lastThree;
  }

  integer = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

  return decimal ? `${integer}.${decimal}` : integer;
}

export const millisecondsToRoundedHours = (ms) => {
  if (ms === null || ms === undefined || isNaN(ms)) return 0;

  const hours = ms / (1000 * 60 * 60);
  const decimalPart = hours % 1;

  if (decimalPart < 0.5) {
    return Math.floor(hours);
  }
  return Math.ceil(hours);
};


// export function useEmailId() {
//   const { currentUser } = useContext(AuthContext);
//   return currentUser?.session?.accessToken?.payload?.username;
// }

export function useEmailId() {
  const userDetails = useSelector((state) => state.users?.userDetails);
  return userDetails?.emailId;
}

// Copies text to the clipboard; falls back to a hidden textarea where the
// Clipboard API is unavailable (http dev hosts, older WebViews). Resolves true on success.
export async function copyTextToClipboard(text) {
  if (!text) return false;
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "absolute";
    ta.style.left = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
